import React, { FC } from 'react';

import { Icon } from '@adsk/alloy-react-icon';

const PlangridColorfulIcon: FC = () => {
  return (
    <Icon size={21} viewBox="0 0 36 36">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9 0C28.7995 0 31.2902 0.01368 33.641 2.36448C35.9849 4.70856 36 7.18848 36 11.1V24.9C36 28.7993 35.9846 31.2917 33.6355 33.641C31.2912 35.9854 28.8118 36 24.9 36H11.1C7.20072 36 4.71 35.9863 2.35896 33.6355C0.0153599 31.2919 0 28.8118 0 24.9V11.1C0 7.20048 0.0148799 4.70856 2.36448 2.35896C4.70856 0.01512 7.18848 0 11.1 0H24.9ZM27.0066 30.2398C28.7854 30.2398 30.2401 28.7851 30.2401 27.0062V16.8451C29.6586 10.6267 24.3702 5.75977 18.0001 5.75977C11.2407 5.75977 5.76007 11.2397 5.76007 17.9998C5.76007 24.5278 10.8627 29.8802 17.3007 30.2398H27.0066ZM25.6545 27.1766C25.6545 28.0092 26.3292 28.6841 27.1617 28.6841C27.9957 28.6841 28.6697 28.0092 28.6697 27.1766C28.6697 26.3436 27.9957 25.6685 27.1617 25.6685C26.3292 25.6685 25.6545 26.3436 25.6545 27.1766ZM8.75208 17.9997C8.75208 12.9002 12.9005 8.7518 17.9995 8.7518C23.099 8.7518 27.2479 12.9002 27.2479 17.9997C27.2479 23.0988 23.099 27.2476 17.9995 27.2476C12.9005 27.2476 8.75208 23.0988 8.75208 17.9997Z"
        fill="#0085DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.24 27.0066C30.24 28.7855 28.7854 30.2401 27.0065 30.2401H17.3006C10.8626 29.8806 5.76001 24.5281 5.76001 18.0001C5.76001 11.2401 11.2406 5.76013 18 5.76013C24.3701 5.76013 29.6585 10.6271 30.24 16.8455V27.0066ZM25.6545 27.177C25.6545 28.0095 26.3292 28.6844 27.1617 28.6844C27.9957 28.6844 28.6697 28.0095 28.6697 27.177C28.6697 26.3439 27.9957 25.6688 27.1617 25.6688C26.3292 25.6688 25.6545 26.3439 25.6545 27.177ZM8.75208 18.0004C8.75208 12.9008 12.9005 8.75244 17.9995 8.75244C23.099 8.75244 27.2479 12.9008 27.2479 18.0004C27.2479 23.0994 23.099 27.2483 17.9995 27.2483C12.9005 27.2483 8.75208 23.0994 8.75208 18.0004Z"
        fill="white"
      />
    </Icon>
  );
};

export default PlangridColorfulIcon;
